import GoBackButton from "@/common/components/GoBackButton";
import { useParams } from "react-router-dom";
import { MaintenanceForwardingsDirectiveFormProps } from "../types/maintenanceForwardingsShowDirectiveDetails.type";
import Button from "@/common/components/Button";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { useState } from "react";

const CreateForwardingDirectiveData = ({ directiveDetails }: MaintenanceForwardingsDirectiveFormProps) => {
  const { companyId, workflowId } = useParams();

  const [showDescription, setShowDescription] = useState(true);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <GoBackButton
          fallback={`/companies/${companyId}/maintenance/workflows/${workflowId}/forwardings/create`}
          searchLastRouteFromFallback
        />

        <p className="text-lg font-bold">
          {directiveDetails.name}
        </p>

        <Button variant="link-white" onClick={() => setShowDescription(!showDescription)}>
          {showDescription ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Button>
      </div>

      {showDescription && (
        <div>
          <p className="text-sm text-white-400 whitespace-pre-wrap">
            {directiveDetails.description}
          </p>
        </div>
      )}
    </div>
  );
}

export default CreateForwardingDirectiveData;
